import { cn } from '@/lib/utils';

interface ScoreBadgeProps {
  score: number | string | null | undefined;
  className?: string;
}

export function ScoreBadge({ score, className }: ScoreBadgeProps) {
  if (score == null) {
    return <span className={cn('text-xs text-muted-foreground', className)}>pending</span>;
  }

  const numScore = typeof score === 'string' ? parseFloat(score) : score;

  if (isNaN(numScore)) {
    return <span className={cn('text-xs text-muted-foreground', className)}>—</span>;
  }

  const color =
    numScore >= 7
      ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
      : numScore >= 5
        ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400'
        : 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400';

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold',
        color,
        className
      )}
    >
      {numScore.toFixed(1)}
    </span>
  );
}
